// @ts-nocheck

/*
you can use it the following way:
1. import it:
import FAIcon from '@/base-components/icons'

2. include it as this:
<FAIcon type="regular" nameIco='fa-folder-open' customClass="h1 p-5" />

*/

import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as solid from '@fortawesome/free-solid-svg-icons'
import * as regular from '@fortawesome/free-regular-svg-icons'
import * as brands from '@fortawesome/free-brands-svg-icons'
import { config } from '@fortawesome/fontawesome-svg-core'
config.autoAddCss = false


const UpperFirst = (sentence: string) =>
{
    if (!sentence || (typeof sentence !== 'string')) return null
    return `${sentence.charAt(0).toUpperCase()}${sentence.slice(1)}`
}

const FAIcon = ({ type, customClass, nameIco, color, style }: any) =>
{
    if (!nameIco) return null

    let finalIcon: any = null

    if (typeof nameIco === 'string')
    {
        const finalName: any = nameIco.split('-').map((cv: any, ind: any) => ind === 0 ? cv : UpperFirst(cv)).join('')

        if (type == 'regular')
        {
            finalIcon = (regular as any)[finalName]
        } else if (type == 'solid')
        {
            finalIcon = (solid as any)[finalName]
        } else if (type == 'brands')
        {
            finalIcon = (brands as any)[finalName]
        } else
        {
            // Fallback: try all sets if type is not specified correctly
            finalIcon = (regular as any)[finalName] || (solid as any)[finalName] || (brands as any)[finalName]
        }
    }
    else if (typeof nameIco === 'object')
    {
        // Allow passing a pre-resolved icon definition object
        finalIcon = nameIco
    }

    if (!finalIcon) return null
    return <FontAwesomeIcon icon={finalIcon} color={color} className={customClass || ''} style={style ?? {}} />
}

export default FAIcon